import React from 'react';

import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartCategoryAxisItem
} from '@progress/kendo-react-charts';

import "hammerjs";
import {numberFormatter} from "../../common/formatter";

import ReportTooltip from '../ReportTooltip';

const ForecastChart = ({forecasts, title, tooltipText}) => {
    const colors = ['#BB61C2', '#26B9CF', '#95dde7'];
    const groups = ['single', 'stack', 'stack'];
    if(!forecasts) return null;

    const data =  [forecasts.expected, forecasts.published, forecasts.review];
    const categories = forecasts.period;
    return (
        <div className='forecast-container'>
            <div className='report-chart-title'>
                <h3 className='font-secondary font-weight-500 font-size-18 text-color-dark'>{title}</h3>
                <ReportTooltip description={tooltipText}/>
            </div>  
            <Chart
                pannable={{
                    lock: "y"
                }}
                zoomable={{
                    mousewheel: {
                    lock: "y"
                    }
                }}
            >
                <ChartSeries>
                    {data.map((value, index) => <ChartSeriesItem
                        key={`forecast-${index}`}
                        type="column"
                        color={colors[index]}
                        border={{
                            color: 'none'
                        }}
                        tooltip={{
                            visible: true,
                            format:"c0"
                        }}
                        
                        style={{strokeWidth: 0}}
                        className='remove-stroke'
                        labels={index !== 1 && {
                            visible: true,
                            format: "c0",
                            content: (e) => `${ numberFormatter.formatShortCurrency((e.stackValue))}`
                        }}
                        stack={{
                            group: groups[index]
                        }}
                        data={value}
                    />)}
                </ChartSeries>
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                        categories={categories}
                        labels={{
                            rotation: "auto"
                        }}/>
                </ChartCategoryAxis>
                <ChartValueAxis>
                    <ChartValueAxisItem
                        labels={{
                            format: "c0"
                        }}
                    />
                </ChartValueAxis>
            </Chart>
            <div className='grouped-legend'>
                <GraphLegend backgroundColor={colors[0]} label='Expected' />
                <GraphLegend backgroundColor={colors[1]} label='Published' />
                <GraphLegend backgroundColor={colors[2]} label='In Review' />
            </div>
        </div>
    );
};

export default ForecastChart;


const GraphLegend = ({backgroundColor, label}) => {
    return (
        <div className='legend-area'>
            <div style={{backgroundColor}}></div>
            <span>{label}</span>
        </div>
    );
};
